import { Component, OnInit } from "@angular/core";
import { DataService_RoleAdminSU } from "../shared/data.service";
import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { RoleSuDistrictUserOptionComponent } from "./role-su-district-user-option/role-su-district-user-option.component";
import { SuRoleSchoolLevelRequest } from "../shared/SuRoleSchoolLevelRequest";

@Component({
	selector: "caass-role-su-district-users",
	templateUrl: "./role-su-district-users.component.html",
	styleUrls: ["./role-su-district-users.component.css"],
})
export class RoleSuDistrictUsersComponent implements OnInit {
	constructor(private dataService: DataService_RoleAdminSU, private confirmationService: ConfirmationService, private dialogService: DialogService) {}

	ngOnInit(): void {
		this.loadUser();
	}

	//////////////////////////////////////////////////////
	// Data
	//////////////////////////////////////////////////////

	pagerows: any = 10;
	pagefirst: any = 0;

	SelectedUsers: any = [];
	lstUser: any = [];

	lstPersonTypeDesc: any = [];
	lstActiveDesc: any = [];

	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "UserName", header: "Username" },
		{ field: "StaffID", header: "Staff ID" },
		{ field: "FirstName", header: "First Name" },
		{ field: "LastName", header: "Last Name" },
		{ field: "PersonTypeDesc", header: "Staff Type" },
		{ field: "SchoolFullName", header: "Home School" },
		// { field: "ActiveDesc", header: "Active" },
		// { field: "SchoolCount", header: "# of Schools" },
	];

	UserLoading: boolean = false;
	Processing: boolean = false;
	errorMessage: any = "";

	//////////////////////////////////////////////////////

	//////////////////////////////////////////////////////
	// Load Data
	//////////////////////////////////////////////////////
	loadUser() {
		this.errorMessage = "";
		this.SelectedUsers = [];
		this.UserLoading = true;

		var result = this.dataService.RoleAdminSuDistrictUserSelectList();
		result.subscribe(
			(response) => {
				this.lstUser = response;

				//Load Data Filter Lists
				this.lstPersonTypeDesc = Array.from(new Set(this.lstUser.map((item: any) => item.PersonTypeDesc)));
				this.lstActiveDesc = Array.from(new Set(this.lstUser.map((item: any) => item.ActiveDesc)));

				this.UserLoading = false;
			},
			(error) => {
				this.UserLoading = false;
			}
		);
	}
	//////////////////////////////////////////////////////

	//////////////////////////////////////////////////////
	// Buttons
	//////////////////////////////////////////////////////

	onRefresh() {
		this.loadUser();
	}

	onMakeSchoolLevel() {
		this.errorMessage = "";

		if (this.SelectedUsers.length == 0) {
			this.errorMessage = "Select Users to make School Level";
			return;
		}

		//
		// Confirm
		//
		this.confirmationService.confirm({
			key: "districtuserconfirm",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message:
				"You are about to make " +
				this.SelectedUsers.length +
				" user" +
				(this.SelectedUsers.length != 1 ? "s" : "") +
				" School Level. Do you want to continue?",
			header: "Confirm Remove District Level",
			icon: "fa",
			accept: () => {
				// Do you want to remove District-Level Roles and User Groups?
				this.onCheckRolesGroups();
			},
		});
	}

	onCheckRolesGroups() {
		var ref = this.dialogService.open(RoleSuDistrictUserOptionComponent, {
			header: "District User Options",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
			},
		});
		ref.onClose.subscribe((response: any) => {
			if (response.Success == true) {
				this.onFinishMakeSchoolLevel(response.RemoveRoles, response.RemoveGroups);
			}
		});
	}

	onFinishMakeSchoolLevel(RemoveRoles: boolean, RemoveGroups: boolean) {
		this.Processing = true;

		var lstUIDs: number[] = this.SelectedUsers.map((user) => user.UserID);

		var parms: SuRoleSchoolLevelRequest = {
			RemoveRoles: RemoveRoles == true ? 1 : 0,
			RemoveGroups: RemoveGroups == true ? 1 : 0,
			lstUserIDs: lstUIDs,
		};

		var result = this.dataService.RoleAdminSuDistrictMakeSchoolLevel(parms);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				if (response.Success == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "districtuserconfirm",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: this.SelectedUsers.length + " user" + (this.SelectedUsers.length != 1 ? "s" : "") + " were updated",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.loadUser();
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "districtuserconfirm",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not Update Users: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onExport() {
		var DataStr: string = "";

		//
		// Add Headers
		//

		DataStr += `"Username",`;
		DataStr += `"Staff ID",`;
		DataStr += `"First Name",`;
		DataStr += `"Last Name",`;
		DataStr += `"Staff Type",`;
		DataStr += `"Home School",`;
		DataStr += `"Active",`;
		DataStr += `"# of Schools"`;
		DataStr += "\n";

		//
		// Add Data
		//
		for (var z = 0; z < this.lstUser.length; z++) {
			var next = this.lstUser[z];

			DataStr += `"` + next.UserName + `",`;
			DataStr += `"` + next.StaffID + `",`;
			DataStr += `"` + next.FirstName + `",`;
			DataStr += `"` + next.LastName + `",`;
			DataStr += `"` + next.PersonTypeDesc + `",`;
			DataStr += `"` + next.SchoolFullName + `",`;
			DataStr += `"` + next.ActiveDesc + `",`;
			DataStr += `"` + next.SchoolCount + `"`;
			DataStr += "\n";
		}

		var a = document.createElement("a"); //Create <a>

		var FileName = "DistrictUsers";

		//
		// Sometimes has issue with plain text, so convert to B64
		//
		DataStr = btoa(DataStr);
		a.href = "data:text/csv;base64," + DataStr;
		a.download = FileName + ".csv";

		a.click(); //Downloaded file
	}

	//////////////////////////////////////////////////////

	//////////////////////////////////////////////////////
	// Events
	//////////////////////////////////////////////////////
	onRowSelect(val) {
		this.errorMessage = "";
	}
	onRowUnselect(val) {
		this.errorMessage = "";
	}
	//////////////////////////////////////////////////////

	//////////////////////////////////////////////////////
	// Helpers
	//////////////////////////////////////////////////////

	IsLoading() {
		return this.UserLoading == true || this.Processing == true;
	}

	//////////////////////////////////////////////////////
}
